import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { loadState, saveState } from "../localStorage";
import languageReducer from "./languageSlice";
//import { store } from './redux/store';
//import store from './store';

//import {store} from "../redux/store" 

//import store from './redux/store'

const preloadedState = loadState(); // Load state from localStorage



const store = configureStore({
  reducer: {
    auth: authReducer,
    language: languageReducer,
    
    
    // links: linksReducer,
  },
  preloadedState, // Use preloaded state
});

// Save state to localStorage
store.subscribe(() => {
  saveState({
    auth: store.getState().auth, // Only save the auth part of the state
    language: store.getState().language,
    links: store.getState().links,
  });
});

export default store;

